import { get, post } from '@/tools/http';

const service = 'cms';

export default {
    namespaced: true,
    state: {
        news: [],
        newsCount: null,
    },
    getters: {
        getNews: state => state.news,
        getNewsCount: state => state.newsCount,
    },
    mutations: {
        setNews: (state, data) => state.news = data,
        setNewsCount: (state, data) => state.newsCount = data,
    },
    actions: {
        fetchNews: async (ctx, {limit = 6, offset = 0} = {}) => {
            const query = `limit=${limit}&offset=${offset}&isPublic=0&sort[0][column]=createdAt&sort[0][order]=DESC`;

            const response = await get(service, `entity/select/news?${query}`);
            
            ctx.commit('setNews', response.list);
            ctx.commit('setNewsCount', response.count);

            return response.list;
        },
    },
};